var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"single-page p-0"},[_c('button-navigation',{attrs:{"link":_vm.mainTab}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }